var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',_vm._l((_vm.rating),function(n){return _c('span',{key:n},[_c('img',{attrs:{"src":require("@/assets/shop/star.svg"),"alt":"","loading":"lazy"}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }